module.exports = __webpack_public_path__ + "img/proses_banding.052159c4.svg";